import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useImmer } from 'use-immer';
import { CmBoxExpandedItem } from '../type';
import { easySnackbar } from '../../../store/Noti/noti.actions';

const useCmBoxExpanded = ({ requestCommentBoxLog = [] }) => {
    /**
     * @type {[CmBoxExpandedItem[], Function]}
     */
    const [cmBoxExpanded, setCmBoxExpanded] = useImmer([]);
    const dispatch = useDispatch();

    const handleCmBoxExpanded = (planId = -1) => {
        const matchedIndex = cmBoxExpanded.findIndex((item) => item.planId === planId);
        if (matchedIndex === -1) return;
        setCmBoxExpanded((draft) => {
            // ---------------- OLD LOGIC (kept for reference) ----------------
            // This allowed multiple comment boxes to be expanded at the same time
            draft[matchedIndex].expanded = !draft[matchedIndex].expanded;
            // ----------------------------------------------------------------
            // ---------------- NEW LOGIC ----------------
            // Only one comment box can be expanded at a time
            // draft.forEach((item, index) => {
            //     if (index === matchedIndex) {
            //         // Toggle the clicked one
            //         item.expanded = !item.expanded;
            //     } else {
            //         // Collapse all others
            //         item.expanded = false;
            //     }
            // });
            // -------------------------------------------
        });
    };

    /**
     * Handles toggling the editing state for a comment box.
     * Only one comment can be edited at a time.
     * If no comment is currently being edited, enables editing for the target.
     * If another comment is being edited, shows a warning.
     * If the same comment is already being edited, does nothing.
     *
     * @function
     * @param {number} planId - The planId of the comment box to edit.
     * @returns {void}
     */
    const handleCmBoxCommentEditing = (planId = -1) => {
        // Find the index of the target comment box and any currently editing comment box
        let targetCmBoxIndex = -1;
        let editingCmBoxIndex = -1;
        for (let index = 0; index < cmBoxExpanded.length; index++) {
            const cmBox = cmBoxExpanded[index];
            if (cmBox.planId === planId) targetCmBoxIndex = index;
            if (cmBox.isEditing) editingCmBoxIndex = index;
        }
        // If no comment is currently being edited, enable editing for the target
        const isAllCmsNotEditing = editingCmBoxIndex === -1;
        if (isAllCmsNotEditing) {
            setCmBoxExpanded((draft) => {
                draft[targetCmBoxIndex].isEditing = true;
            });
            return;
        }
        // If another comment is being edited, show a warning and do not allow editing multiple
        if (targetCmBoxIndex !== editingCmBoxIndex) {
            if (targetCmBoxIndex !== -1) {
                dispatch(easySnackbar('Only one comment can be edited at a time.', 'warning'));
            }
            return;
        }
    };

    useEffect(() => {
        if (!requestCommentBoxLog || !requestCommentBoxLog.length) return;
        setCmBoxExpanded(
            requestCommentBoxLog.map((v, i) => {
                return {
                    // Only the latest comment box is expanded by default
                    expanded: i === requestCommentBoxLog.length - 1,
                    planNumber: v.plan_no,
                    planId: v.plan_id,
                    isEditing: false,
                };
            })
        );
    }, [requestCommentBoxLog]);

    return {
        cmBoxExpanded,
        setCmBoxExpanded,
        handleCmBoxExpanded,
        handleCmBoxCommentEditing,
    };
};

export default useCmBoxExpanded;
